export default function detailevent (event = {}, action) { 
    switch (action.type) {
    case "DATA_DETAIL":
　      return JSON.parse(action.response.data.body)
    default: 
        return event 
    }
}
